export default __webpack_public_path__ + "static/media/PPI-pools-035.ea065a84.jpg";